import { HubConnectionBuilder, HubConnectionState, LogLevel } from "@microsoft/signalr";

export class SignalRCore {
  static HUBS = {};
  static connectionId(hub) {
    return SignalRCore.HUBS[hub]?.connection?.connectionId;
  }
  static closeAllConnections = () => {
    Object.keys(SignalRCore.HUBS).forEach((key) => {
      const hub = SignalRCore.HUBS[key];
      hub.stop();
    });
    SignalRCore.HUBS = {};
  };
  build = (url, token) => {
    if (SignalRCore.HUBS[url]) {
      this.hub = SignalRCore.HUBS[url];
    } else {
      this.hub = new HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(url, {accessTokenFactory: () => {
          return token;
        }})
        .configureLogging(LogLevel.Information)   
        .build();
      SignalRCore.HUBS[url] = this.hub;
      this.start();
    }
    this.on = this.hub.on.bind(this.hub);
    this.off = this.hub.off.bind(this.hub);
  };
  /**
   * @returns {Promise<SignalRCore>}
   * @private
   */
  start = () => {
    return new Promise((resolve) => {
      const state = this.hub?.state;
      if (state === HubConnectionState.Disconnected) {
        this.hub.start().then(() => {
          resolve(this);
        });
      } else {
        resolve(this);
      }
    });
  };

  get connectionId() {
    return this.hub?.connection?.connectionId;
  }

  onConnected = (cb) => {
    if (this.hub.state !== HubConnectionState.Connected) {
      setTimeout(() => this.onConnected(cb), 200);
    } else {
      cb();
    }
  };
}
